import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import {
  getGapAnalysisControlDetails,
  updateStatusControl,
  updateMaturityLevel,
  updateStatusObjectiveControl,
} from '../../../../services/gap-analysis';
import { PageLoaderShow } from '../../../../Components/PageLoader/Show';
import { Container } from 'Components/Container';
import { Card } from 'Components/Card';
import React, { useEffect, useState } from 'react';
import {
  CardContent, Typography, Select, MenuItem, Button,
  Accordion, AccordionSummary, AccordionDetails, Chip, FormControl, InputLabel, Snackbar, Alert,
} from '@mui/material';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { Title } from './styles'
import { Column, Row  } from '../../../../Components/Grid';
import { useSelector } from 'react-redux';
import { useAuthTenant } from '../../../../store/auth';
import { getCompanyById } from '../../../../services/company-service';
import { getAssetById } from '../../../../services/assets-service';
import { getAreaById } from '../../../../services/areas-service';
import { getProcessById } from '../../../../services/processes-service';
import { getSystemById } from '../../../../services/systems-service';
import { typeLabelKeys, getSolutionKey, statusControl, maturityLevelKeys, getBreadcrumbBase, translateDomain, translateFunctionGrouping, translateApplicability } from '../../../../utils/labels_utils'
import { useLocation } from 'react-router-dom';

const options = [
  { label: "Empresa", value: "companies", fetchFunction: getCompanyById },
  { label: "Áreas de negócio", value: "areas", fetchFunction: getAreaById },
  { label: "Processos", value: "processes", fetchFunction: getProcessById },
  { label: "Sistemas", value: "systems", fetchFunction: getSystemById },
  { label: "Ativos", value: "assets", fetchFunction: getAssetById },
];


export const GapAnalysisControlDetalShow = () => {
  const { t } = useTranslation(['gap-analysis', 'common']);
  const { id } = useParams();
  const selectedTenant = useSelector(useAuthTenant);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
  const [statuses, setStatuses] = useState({});
  const [currentLevel, setCurrentLevel] = useState("notPerformed");
  const [selectedStatus, setSelectedStatus] = useState("noResponse");
  const [entityData, setEntityData] = useState(null);
  const location = useLocation();
  const breadcrumbBase = getBreadcrumbBase(location.pathname, t);


  const {
    isLoading,
    error,
    data: control,
  } = useQuery('getGapAnalysisControlDetails', async () => {
    const data = await getGapAnalysisControlDetails(id);
    return data.status === 200 ? data.data : null;
  });



  useEffect(() => {
    if (control?.objectives) {
      setStatuses(control.objectives.reduce((acc, obj) => ({ ...acc, [obj._id]: obj.status }), {}));
    }
    if (control && control.maturity_level) {
      setCurrentLevel(control.maturity_level);
    }
    if (control && control.status) {
      setSelectedStatus(control.status);
    }
    if (control?.entity_type && control?.entity_id) {
      const selectedOption = options.find(option => option.value === control.entity_type);
      if (selectedOption) {
        selectedOption.fetchFunction(control.entity_id)
          .then(response => setEntityData(response.data))
          .catch(error => console.error("Erro ao buscar entidade:", error));
      }
    }

  }, [control]);
  const getStatusProps = (status) => {
    switch (status) {
      case "attended":
        return { label: t('gap-analysis:controlDetail.status.attended'), color: "success", icon: <CheckCircleIcon style={{ color: "green", marginTop: "5px" }} /> };
      case "notAttended":
        return { label: t('gap-analysis:controlDetail.status.notAttended'), color: "error", icon: <CancelIcon style={{ color: "red", marginTop: "5px" }} /> };
      case "notApplicable":
        return { label: t('gap-analysis:controlDetail.status.notApplicable'), color: "success", icon: <CheckCircleIcon style={{ color: "green", marginTop: "5px" }} /> };
      default:
        return { label: t('gap-analysis:controlDetail.status.notAnswered'), color: "default", icon: <RadioButtonUncheckedIcon style={{ color: "#B0B0B0", marginTop: "5px" }} /> };
    }
  };

  const handleUpdateMaturityLevel = async (idControl, maturityLevel) => {
    if (!maturityLevel) {
      setSnackbar({ open: true, message: "Please select a maturity level.", severity: "warning" });
      return;
    }

    try {
      await updateMaturityLevel(idControl, maturityLevel);
      setSnackbar({ open: true, message: t('gap-analysis:controlDetail.messages.maturitySuccess'), severity: "success" });
    } catch (error) {
      console.error("Error updating maturity level:", error);
      setSnackbar({ open: true, message: t('gap-analysis:controlDetail.messages.maturityError'), severity: "error" });
    }
  };


  const handleStatusControlChange = async (newStatus) => {
    setSelectedStatus(newStatus);
    try {
      await updateStatusControl(id, newStatus);
      setSnackbar({ open: true, message: t('gap-analysis:controlDetail.messages.statusSuccess'), severity: "success" });
    } catch (error) {
      console.error("Error updating status:", error);
      setSnackbar({ open: true, message: t('gap-analysis:controlDetail.messages.statusError'), severity: "error" });
    }
  };


  const handleStatusChange = async (idObjective, newStatus) => {
    setStatuses((prevStatuses) => ({
      ...prevStatuses,
      [idObjective]: newStatus, // Atualiza o estado localmente
    }));

    try {
      await updateStatusObjectiveControl(idObjective, newStatus);
      setSnackbar({ open: true, message: t('gap-analysis:controlDetail.messages.objectiveSuccess'), severity: "success" });
    } catch (error) {
      console.error("Error updating status:", error);
      setSnackbar({ open: true, message: t('gap-analysis:controlDetail.messages.objectiveError'), severity: "error" });
    }
  };

  const employeeSize = parseFloat(selectedTenant.size);

  const solutionKey = getSolutionKey(employeeSize);
  return (
    <>
      {!isLoading && !error && (
        <Container
          title={`${control.controlDetail.scfControl}`}
          breadcrumb={`${breadcrumbBase} / ${control.controlDetail.scfControl}`}
          linkPage={-1}
          actionButton={
            <>
              <FormControl variant="outlined" style={{ minWidth: 200 }}>
                <InputLabel id="status-label" shrink={true}>
                  {t('common:labels.status')}
                </InputLabel>

                <Select
                  labelId="status-label" notched label={t('common:labels.status')}
                  value={selectedStatus}
                  variant="outlined"
                  onChange={(e) => handleStatusControlChange(e.target.value)}
                  sx={{
                    borderRadius: '40px',
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '40px',
                    }
                  }}
                >
                  {Object.entries(statusControl)
                    .filter(([key]) => key !== "noEntities")
                    .map(([key, value]) => (
                      <MenuItem key={key} value={key}>
                        {t(value.labelKey)}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </>
          }
        >
          <Row className="px-2 mt-3 mb-3">
            <Column xs={12}>
              <Card>
                <Title className="m-0 mb-3">{t('gap-analysis:controlDetail.entityDetails')}</Title>

                <div style={{ display: "flex", gap: "16px", marginBottom: "16px" }}>
                  <Typography><strong>{t('common:labels.name')}:</strong> {entityData?.name || t('common:labels.notAvailable')}</Typography>
                  <Typography><strong>{t('gap-analysis:controlDetail.fields.criticality')}</strong> {entityData?.criticity || t('common:labels.notInformed')}</Typography>
                  <Typography><strong>{t('common:labels.type')}:</strong> {typeLabelKeys[control?.entity_type] ? t(typeLabelKeys[control.entity_type]) : t('common:labels.notInformed')}</Typography>
                </div>

                <Typography>
                  <strong>{t('common:labels.description')}:</strong> {entityData?.description || t('common:empty.noDescription')}
                </Typography>
              </Card>

            </Column>
          </Row>

          <Row className="px-2 mt-3 mb-3">
            <Column xs={12}>
              <Card>
                <Title className="m-0 mb-3">{t('gap-analysis:controlDetail.overview')}</Title>
                <div style={{ display: "flex", gap: "16px", marginBottom: "16px" }}>
                  <Typography><strong>{t('gap-analysis:show.filters.domain')}:</strong> {translateDomain(t, control.controlDetail.scfDomain)}</Typography>
                  <Typography><strong>{t('gap-analysis:controlDetail.fields.functionGroup')}</strong> <span>{translateFunctionGrouping(t, control.controlDetail.nistCsfFunctionGrouping)}</span></Typography>
                  <Typography><strong>{t('gap-analysis:controlDetail.fields.applicability')}</strong> {translateApplicability(t, control.controlDetail.applicabilityStatus)}</Typography>
                  <Typography><strong>{t('gap-analysis:controlDetail.fields.controlWeight')}</strong> {control.controlDetail.controlWeighting}</Typography>
                </div>

                <Typography>
                  <strong>{t('gap-analysis:controlDetail.fields.controlDesc')}</strong> {control.controlDetail.scfControlDescription}
                </Typography>
                <Typography style={{ marginTop: "16px" }}>
                  <strong>{t('gap-analysis:controlDetail.fields.requirements')}</strong>
                </Typography>
                {control.frameworkDetails
                  .filter(framework => control.controlDetail.frameworks[framework._id]?.length)
                  .map(framework => (
                    <Typography key={framework._id}>
                      {framework.sourceIdentifier}: {control.controlDetail.frameworks[framework._id].join(", ")}
                    </Typography>
                  ))}


                <Typography style={{ marginTop: "16px" }}>
                  <strong>{t('gap-analysis:controlDetail.fields.methods')}</strong>
                  <Typography style={{ whiteSpace: "pre-line" }}>
                    {control.controlDetail[solutionKey]}
                  </Typography>
                </Typography>

              </Card>
            </Column>
          </Row>
          <Row className="px-2 mt-3 mb-3">
            <Column xs={12}>
              <Card>
                <Title className="m-0">{t('gap-analysis:controlDetail.objectives')}</Title>
                <CardContent sx={{ maxHeight: "300px", overflowY: "auto" }}>
                  {control.objectives.map((obj) => {

                    const statusProps = getStatusProps(statuses[obj._id] || "notResponded");
                    return (
                      <Accordion key={obj._id}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                          <Typography>{obj.details.scfAssessmentObjective}</Typography>
                          <Chip
                            label={statusProps.label}
                            color={statusProps.color}
                            style={{ marginLeft: "auto", width:'auto'}}
                          />
                          {statusProps.icon}
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography>{obj.details.scfAoId}</Typography>
                          <Select
                            value={statuses[obj._id] || "notResponded"}
                            onChange={(e) => handleStatusChange(obj._id, e.target.value)}
                            fullWidth
                            style={{ marginTop: "16px" }}
                            variant="outlined"
                          >
                            <MenuItem value="notResponded">{t('gap-analysis:controlDetail.status.notAnswered')}</MenuItem>
                            <MenuItem value="attended">{t('gap-analysis:controlDetail.status.attended')}</MenuItem>
                            <MenuItem value="notAttended">{t('gap-analysis:controlDetail.status.notAttended')}</MenuItem>
                            <MenuItem value="notApplicable">{t('gap-analysis:controlDetail.status.notApplicable')}</MenuItem>
                          </Select>
                        </AccordionDetails>
                      </Accordion>
                    );
                  })}
                </CardContent>
              </Card>
            </Column>
          </Row>
          <Row className="px-2 mt-3 mb-3">
            <Column xs={12}>
              <Card style={{ padding: "16px" }}>
                <Title className="m-0">{t('gap-analysis:controlDetail.maturityLevelTitle')}</Title>
                <CardContent>
                  <div style={{ marginTop: "16px" }}>
                    <Typography variant="body1" fontWeight="bold">{t('gap-analysis:controlDetail.currentMaturity')}</Typography>
                    <Select
                      id="maturitySelect"
                      value={currentLevel}
                      onChange={(e) => setCurrentLevel(e.target.value)}
                      fullWidth
                      style={{ marginTop: "8px" }}
                      variant="outlined"
                    >
                      {Object.entries(maturityLevelKeys)
                        .filter(([key]) => key !== "noEntities")
                        .map(([key, transKey]) => (
                          <MenuItem key={key} value={key}>{t(transKey)}</MenuItem>
                        ))}
                    </Select>

                    <Button
                      variant="contained"
                      sx={{ mt: 2 }}
                      onClick={() => handleUpdateMaturityLevel(id, currentLevel)}
                    >
                      {t('common:buttons.update')}
                    </Button>
                  </div>

                  <div style={{ marginTop: "16px" }}>
                    <Typography variant="body1" fontWeight="bold">{maturityLevelKeys[currentLevel] ? t(maturityLevelKeys[currentLevel]) : currentLevel}</Typography>
                    <Typography variant="body2" color="textSecondary" style={{ whiteSpace: "pre-line" }}>
                      {control.controlDetail[currentLevel]}
                    </Typography>
                  </div>
                </CardContent>
              </Card>
            </Column>
            <Snackbar
              open={snackbar.open}
              autoHideDuration={3000}
              onClose={() => setSnackbar({ ...snackbar, open: false })}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
              <Alert severity={snackbar.severity} onClose={() => setSnackbar({ ...snackbar, open: false })}>
                {snackbar.message}
              </Alert>
            </Snackbar>
          </Row>

        </Container>
      )}
      {isLoading && <PageLoaderShow />}
      {error && <div>{t('gap-analysis:controlsLink.error')}</div>}
    </>
  )
}